import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/debounceTime";

import { Types, Creators } from "../reducer";

import * as firebase from 'firebase';

const synchronizeRegistration = registrationId =>
  firebase.database().ref("sync").set({
    [registrationId]: {
      status: "pending"
    }
  });

export default (action$, store) =>
  action$
    .ofType(Types.SYNCHRONIZE_REGISTRATION)
    .debounceTime(250)
    .mergeMap(action =>
      synchronizeRegistration(action.registrationId).then(() =>
        Creators.synchronizeStarted(action.registrationId)
      )
    );



// WEBPACK FOOTER //
// ./src/registration/epics/synchronizeRegistration.js